import React from 'react'
import PropTypes from 'prop-types'

import logo from '@assets/images/unimed-assis/companyLogos/CasaDiContiLogo.svg'
import { Container, Logo, CompanyName } from './styles'

const CompanyDisplay = ({ companyName }) => (
  <Container>
    {companyName === 'Casa Di Conti' && (
    <Logo>
      <img src={logo} alt="Casa Di Conti Logo" />
    </Logo>
    )}
    <CompanyName>{companyName}</CompanyName>
  </Container>
)

CompanyDisplay.propTypes = {
  companyName: PropTypes.string,
}

CompanyDisplay.defaultProps = {
  companyName: 'Casa Di Conti',
}

export default CompanyDisplay
